<template>
  <div>
    <div
      class="el-centered eu-fade-in"
      v-if="globalLoading && !globalError"
    >
      <emd-pagarme-loader :color="'secondary'" />
    </div>
    <div
      class="app-error-wrapper"
      v-if="!globalLoading && globalError"
    >
      <logo-stone-rebrand class="app-error-wrapper__logo" />
      <global-error
        theme="pagarme"
        :showLogo="false"
        :code="code"
      />
    </div>
    <template v-else-if="!globalLoading && !globalError">
      <router-view />
    </template>
  </div>
</template>

<script>
import { GlobalError, EmdPagarmeLoader } from 'emerald-vue/src/components'
import LogoStoneRebrand from '@/components/emerald/atoms/LogoStoneRebrand.vue'

export default {
  name: 'app',
  components: { GlobalError, EmdPagarmeLoader, LogoStoneRebrand },
  computed: {
    globalError () {
      return this.$store.state.globalError
    },
    code () {
      return this.$store.state.globalErrorCode
    },
    globalLoading () {
      return this.$store.getters.globalLoading
    },
    pref () {
      return this.$store.getters.pref
    }
  },
  beforeMount: function () {
    const body = document.body
    this.$store.dispatch('GET_PREFERENCES').then(() => {
      const preferences = Object.assign({}, this.pref)
      if (preferences.appearance.mode === 'light') {
        body.classList.remove('_mode_dark')
      } else {
        body.classList.add('_mode_dark')
      }
      this.$store.dispatch('SET_PREFERENCES', preferences)
    })
  }
}
</script>

<style scoped>
.app-error-wrapper {
  position: relative;
}

.app-error-wrapper__logo {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
</style>
